import React, { useState } from "react";
import theme from "@/theme";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export const LoginForm = (props = {}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(null);
  const [email, setEmail] = useState(null);
  const isWrongPassword = !props.validity.password && password !== null;
  const isWrongEmail = !props.validity.email && email !== null;
  const shouldDisableLogin =
    isWrongEmail || isWrongPassword || email === null || password === null;

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => event.preventDefault();

  const handlePasswordChange = (event = {}) => {
    const { target = {} } = event;
    const { value = "" } = target;
    props.onValidate({ value, field: "password" });
    setPassword(value);
  };

  const handleEmailChange = (event = {}) => {
    const { target = {} } = event;
    const { value = "" } = target;
    props.onValidate({ value, field: "email" });
    setEmail(value);
  };

  return (
    <Grid
      sx={{
        margin: "80px auto",
        textAlign: "center",
        paddingLeft: "30px",
        paddingRight: "30px",
        maxWidth: 500,
      }}
    >
      <Grid container>
        <FormControl
          sx={{ width: "100%", marginBottom: "20px" }}
          variant="standard"
        >
          <InputLabel htmlFor="standard-adornment-password">
            {props.labels.email}
          </InputLabel>
          <Input
            type={"email"}
            value={email || ""}
            onChange={handleEmailChange}
            error={isWrongEmail}
            disabled={props.isLoading}
            endAdornment={
              <InputAdornment position="end">
                <AlternateEmailIcon />
              </InputAdornment>
            }
          />
          {isWrongEmail && (
            <FormHelperText error>{props.labels.invalidEmail}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid container columns={{ md: 12 }}>
        <FormControl
          sx={{ width: "100%", marginBottom: "20px" }}
          variant="standard"
        >
          <InputLabel htmlFor="standard-adornment-password">
            {props.labels.password}
          </InputLabel>

          <Input
            id="standard-adornment-password"
            type={showPassword ? "text" : "password"}
            value={password || ""}
            onChange={handlePasswordChange}
            error={isWrongPassword}
            disabled={props.isLoading}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  disabled={props.isLoading}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {isWrongPassword && (
            <FormHelperText error>
              {props.labels.invalidPassword}
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
      {props.isLoading ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress sx={{ margin: "0px auto" }} />
        </Box>
      ) : (
        <Button
          disabled={shouldDisableLogin}
          onClick={() => props.onSubmit({ email, password })}
          variant="contained"
          sx={{ width: "100%", backgroundColor: theme.palette.primary.main }}
        >
          {props.labels.login}
        </Button>
      )}
    </Grid>
  );
};

export default LoginForm;
